import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Fase } from '../models/fase';
import { Result } from '../models/result';

@Injectable({ providedIn: 'root' })
export class FaseService {
  apiUrl = environment.urlControlCenterApi + 'fase';

  constructor(private http: HttpClient) {}

  getById(id: number) {
    return this.http.get<Result<Fase>>(`${this.apiUrl}/${id}`);
  }

  getAll() {
    return this.http.get<Result<Fase[]>>(`${this.apiUrl}`);
  }

  insert(data: Fase) {
    return this.http.post<Result<Fase>>(this.apiUrl, data);
  }

  update(data: Fase) {
    return this.http.put<Result<Fase>>(`${this.apiUrl}`, data);
  }

  delete(id: number) {
    return this.http.delete<Result<boolean>>(`${this.apiUrl}/${id}`);
  }
}
